package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.CheckMark
import co.maytes.standupbot.dashboard.components.widgets.ControlSize
import co.maytes.standupbot.dashboard.components.widgets.metrics
import co.maytes.standupbot.dashboard.styles.ControlClass
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.RadioInput
import org.jetbrains.compose.web.dom.Span

internal fun Modifier.asCheckRow(): Modifier = classNames(ControlClass.CHECK)

@Composable
internal fun RowCheckControl(
    checked: Boolean,
    disabled: Boolean,
    onToggle: () -> Unit,
) {
    CheckboxInput(
        checked = checked,
        attrs = Modifier
            .classNames(ControlClass.CHECK_INPUT)
            .toAttrs {
                if (disabled) attr("disabled", "")
                onInput { if (!disabled) onToggle() }
            },
    )
    Span(
        attrs = Modifier
            .classNames(ControlClass.CHECK_BOX)
            .width(ControlSize.Md.metrics.boxPx.px)
            .height(ControlSize.Md.metrics.boxPx.px)
            .toAttrs { attr("aria-hidden", "true") },
    ) { CheckMark() }
}

@Composable
internal fun RowRadioControl(
    selected: Boolean,
    groupName: String,
    onSelect: () -> Unit,
) {
    RadioInput(
        checked = selected,
        attrs = Modifier
            .classNames(ControlClass.CHECK_INPUT)
            .toAttrs {
                name(groupName)
                onInput { onSelect() }
            },
    )
    Span(
        attrs = Modifier
            .classNames(ControlClass.RADIO_BOX)
            .width(ControlSize.Md.metrics.boxPx.px)
            .height(ControlSize.Md.metrics.boxPx.px)
            .toAttrs { attr("aria-hidden", "true") },
    )
}
